import customerService from "../../../services/customers.service"
import customerDomainService from "@/services/customerDomain.service";

export default {
    createCustomer({ dispatch }, params) {
        return customerService.createCustomer(params)
            .then(response => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
             return error
            })
    },
    updateCustomer({ commit, dispatch }, data) {
        return customerService.updateCustomer(data)
            .then(response => {
                commit('UPDATE_CUSTOMER', data)
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
                return data
            })
            .catch(error => {
                return error
            })
    },
    search({ commit, dispatch }, payload) {
        return customerService.search(payload)
            .then(response => {
                commit('SET_CUSTOMERS', response.data.data)
                commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
                return Promise.resolve(response.data.data)
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    getCustomers({ commit, dispatch }, payload) {
        return customerService.getCustomers(payload)
            .then(response => {
                commit('SET_CUSTOMERS', response.data.customers.data)
                commit('SET_INFO_DB', { totalPage: response.data.customers.last_page, totalRow: response.data.customers.total })
                commit('subscriptions/SET_SUBSCRIPTION', response.data.subscriptions, { root: true })
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    getCustomer({ dispatch }, id) {
        return customerService.getCustomer(id)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    deleteCustomers({ commit, dispatch }, ids) {
        return customerService.deleteCustomers({ cids: ids })
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    deleteCustomer({ commit, dispatch }, id) {
        return customerService.deleteCustomer(id)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    importCustomer({ commit, dispatch }, data, headers) {
        return customerService.importCustomer(data, headers)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                return error
            })
    },
    getCustomerLinkedDomain({dispatch}){
        return customerDomainService.getCustomerLinked()
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    createCustomerField({dispatch},payload){
        return customerService.createCustomerField(payload)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    getCustomerFieldsByCompany({dispatch}){
        return customerService.getCustomerFieldsByCompany()
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    updateFieldNameCompanyCustomize({dispatch},payload){
        return customerService.updateFieldNameCompanyCustomize(payload)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    deleteFieldNameCompanyCustomize({dispatch},id){
        return customerService.deleteFieldNameCompanyCustomize(id)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                } else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
}
